import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import '../../MainStyle.css';
import { API_GET_PROFILE, API_UPDATE_ACCOUNT } from '../modals/Constants';
import HeaderView from "../other-components/HeaderView/view";
import { getStorage, setStorage } from '../modals/Storage';
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import AlertDialog from "../dialogs/AlertDialog/dialog";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";

function Onboard() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const [searchParams] = useSearchParams();
    const accountID = searchParams.get("id") || "";
    const accountAuthorization = searchParams.get("auth") || "";

    const [inEmailId, setInEmailId] = useState("");
    const [inMobileNum, setInMobileNum] = useState("");
    const [inFullName, setInFullName] = useState("");
    const [inPassword, setInPassword] = useState("");
    const [inMobilePreFilled, setMobilePreFilled] = useState(true);

    const [alertDialog, updatetAlertDialog] = useState({
        title: 'Required!',
        description: '',
        visible: false
    });

    function setAlertDialog({ title = '', description = '', visible = true }) {
        if (title === '') {
            title = alertDialog.title;
        }

        updatetAlertDialog((previousState) => {
            return {
                ...previousState,
                title: title,
                description: description,
                visible: visible
            };
        });
    }

    const updateAccount = () => {
        const requestAPI = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${accountAuthorization}`,
                    },
                    body: JSON.stringify(formData),
                });

                const response = await res.json();
                const account = response.data;
                setLoading(false);

                if (response.status_code === "success") {
                    setStorage("accountID", account.account_id);
                    setStorage("accountSecret", account.account_secret);
                    navigate("/", { replace: true });
                } else if (response.status_code === "already_exist") {
                    setAlertDialog({ title: "Error", description: "Mobile number or Email ID already exist!" });
                } else {
                    setAlertDialog({ title: "Error", description: "There was a technical issue! Please try again!" });
                }
            } catch (error) {
                setLoading(false);
                setAlertDialog({ title: "Error", description: "There was a technical issue! Please try again!" });
            }
        };

        if (inMobileNum != "" && inFullName != "" && inPassword) {
            setLoading(true);
            const formData = {
                ACCOUNT_ID: accountID,
                ACCOUNT_EMAIL: inEmailId,
                ACCOUNT_MOBILE: inMobileNum,
                ACCOUNT_FULLNAME: inFullName,
                ACCOUNT_PASSWORD: inPassword
            };
            requestAPI(API_UPDATE_ACCOUNT, formData);
        }
    }

    const getRecords = () => {
        const requestAPI = async (url, formData) => {
            try {
                const res = await fetch(url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': `Bearer ${accountAuthorization}`,
                    },
                    body: JSON.stringify(formData),
                });

                const response = await res.json();
                setLoading(false);

                if (response.status_code === "success") {
                    if (response.data.mobile !== "") {
                        setMobilePreFilled(true);
                    } else {
                        setMobilePreFilled(false);
                    }

                    setInFullName(response.data.username);
                    setInEmailId(response.data.email);
                    setInMobileNum(response.data.mobile);
                }
            } catch (error) {
                setLoading(false);
                setAlertDialog({ title: "Error", description: "There was a technical issue! Please try again!" });
            }
        };

        setLoading(true);
        const formData = { ACCOUNT_ID: accountID, ONBOARD: true };
        requestAPI(API_GET_PROFILE, formData);
    }

    useEffect(() => {
        if (!accountID || !accountAuthorization) return;
        getRecords()
    }, []);

    return (
        <div className={[general.appView]}>
            <AlertDialog
                isOpen={alertDialog.visible}
                title={alertDialog.title}
                description={alertDialog.description}
                onClose={() => setAlertDialog({ visible: false })}
                actions={[
                    { label: "Close", variant: "neutral", onClick: () => setAlertDialog({ visible: false }) }
                ]}
            />
            <LoadingDialog
                isOpen={loading}
            />

            <div className={[general.appChildView]}>
                <HeaderView screen={"profile"} />

                <div className={general.appLocationViews}>
                    <p>One last step to get started.</p>
                </div>

                <div className={[general.appContentsView]}>
                    <div className={[screen.profileView].join(" ")}>
                        <div>
                            <span className='ft-sz-13'>Full Name</span>
                            <div className={general.inpBoxOutline}>
                                <input type="text" autoComplete="new-password" value={inFullName} onChange={e => setInFullName(e.target.value)}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>Email Id (optional)</span>
                            <div className={general.inpBoxOutline}>
                                <input type="text" autoComplete="new-password" value={inEmailId} onChange={e => setInEmailId(e.target.value)} readOnly={!inMobilePreFilled}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>Mobile</span>
                            <div className={general.inpBoxOutline}>
                                <input type="number" autoComplete="new-password" value={inMobileNum} onChange={e => setInMobileNum(e.target.value)} readOnly={inMobilePreFilled}></input>
                            </div>
                        </div>

                        <div>
                            <span className='ft-sz-13'>Password</span>
                            <div className={general.inpBoxOutline}>
                                <input type="password" autoComplete="new-password" onChange={e => setInPassword(e.target.value)}></input>
                            </div>
                        </div>
                    </div>

                    <button className={[general.primaryBtn, general.rounded1x].join(" ")} onClick={() => updateAccount()}>Create an account</button>
                </div>
            </div>
        </div>
    );
}

export default Onboard;